import React from 'react';

export const DecorationUnderline = () => {
    return (
        <svg width="243" height="26" viewBox="0 0 243 26" fill="none" xmlns="http://www.w3.org/2000/svg">
            <path
                d="M10.5181 15.5743C10.5181 15.5743 76.2222 11.7125 119.629 10.7341C163.035 9.7558 232.725 10.7341 232.725 10.7341"
                stroke="url(#paint0_linear_10_106)" stroke-width="19.781" stroke-linecap="round"/>
            <defs>
                <linearGradient id="paint0_linear_10_106" x1="10.5181" y1="12.9368" x2="232.725" y2="12.9368"
                                gradientUnits="userSpaceOnUse">
                    <stop stop-color="#934CFF" stop-opacity="0.1"/>
                    <stop offset="0.649295" stop-color="#934CFF" stop-opacity="0.4"/>
                    <stop offset="1" stop-color="#934CFF" stop-opacity="0.2"/>
                </linearGradient>
            </defs>
        </svg>

    )
}